export default __webpack_public_path__ + "static/media/koo.1bc73732.png";